var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjectDetection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.ObjectDetection-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ObjectDetection-st0",
    d: "M1.5,1.5v4.4c0,0.4-0.3,0.7-0.7,0.7S0,6.3,0,5.9V0.7C0,0.3,0.3,0,0.7,0h5.1c0.4,0,0.7,0.3,0.7,0.7 S6.3,1.5,5.9,1.5H1.5z M23.5,1.5h-4.4c-0.4,0-0.7-0.3-0.7-0.7S18.7,0,19.1,0h5.1C24.7,0,25,0.3,25,0.7v5.1c0,0.4-0.3,0.7-0.7,0.7 c-0.4,0-0.7-0.3-0.7-0.7L23.5,1.5z M1.5,23.5h4.4c0.4,0,0.7,0.3,0.7,0.7c0,0.4-0.3,0.7-0.7,0.7H0.7C0.3,25,0,24.7,0,24.3v-5.1 c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.7L1.5,23.5z M23.5,23.5v-4.4c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7v5.1 c0,0.4-0.3,0.7-0.7,0.7h-5.1c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7H23.5z M6,18.1h13L12.5,6.9L6,18.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectDetection);
export default __webpack_public_path__ + "static/media/ObjectDetection.c6ab8936e96748402e4a0bee431ad10b.svg";
export { ForwardRef as ReactComponent };